// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__hxbOK","obliqueLineWrap":"membershipbadge_obliqueLineWrap__2Mzr2","obliqueLine":"membershipbadge_obliqueLine__29p14"};